import TabMenu from './TabMenu.vue';

export default TabMenu;
